import { buildRing, buildStadium, buildCircuit, type TrackDef } from '../sim/track';
import type { Vec2 } from '../sim/track';
import { WORLD_HEIGHT, WORLD_WIDTH } from '../config';

/**
 * Points de contrôle d'un circuit « ovale à rayon modulé » : courbure variée (virages plus ou
 * moins serrés, sections rapides) mais lisse — pas de cusp, contrairement à des waypoints à la main.
 */
function wavyWaypoints(): Vec2[] {
  const cx = WORLD_WIDTH / 2;
  const cy = WORLD_HEIGHT / 2;
  const rx = 430;
  const ry = 205;
  const n = 18;
  const out: Vec2[] = [];
  for (let i = 0; i < n; i++) {
    const a = (2 * Math.PI * i) / n;
    const r = 1 + 0.14 * Math.sin(2 * a) + 0.09 * Math.sin(3 * a + 0.7);
    out.push({ x: cx + rx * r * Math.cos(a), y: cy + ry * r * Math.sin(a) });
  }
  return out;
}

/** Registre des circuits, résolus par nom depuis les scénarios. */
export const TRACKS: Record<string, TrackDef> = {
  ring: buildRing({
    name: 'ring',
    cx: WORLD_WIDTH / 2,
    cy: WORLD_HEIGHT / 2,
    radius: 220,
    halfWidth: 70,
    laps: 3,
    sampleCount: 90,
    checkpointCount: 12,
  }),
  // « Stade » : 2 lignes droites de 600 px + 2 virages de rayon 170. Vrai banc d'essai.
  stadium: buildStadium({
    name: 'stadium',
    cx: WORLD_WIDTH / 2,
    cy: WORLD_HEIGHT / 2,
    halfStraight: 300,
    radius: 170,
    halfWidth: 64,
    laps: 3,
    checkpointCount: 12,
  }),
  // « Circuit » : ovale à rayon modulé → courbure variée (virages serrés/rapides) pour tester l'IA.
  complex: buildCircuit({
    name: 'complex',
    waypoints: wavyWaypoints(),
    halfWidth: 52,
    laps: 3,
    checkpointCount: 16,
  }),
};

export function getTrack(name: string | null | undefined): TrackDef | undefined {
  if (!name) return undefined;
  return TRACKS[name];
}
